import { ArticleRounded, CloseRounded, EditRounded, ImageRounded, PrintRounded, ReceiptRounded, RemoveCircleRounded, SwapHorizRounded } from "resource/muiImport"
import { Button, CircularProgress, IconButton, MenuItem, Paper, TextField, Typography } from "@mui/material"
import { pettyCashApiNm, pettyCashColNm } from "./constant"
import { numberFormat } from "utils"
import dayjs from "dayjs"
import { GridActionsCellItem } from "@mui/x-data-grid"
import { BoxFC, BoxFR } from "components/BoxCustom"
import { expenseColNm } from "constants/expenseConstant"
import { jobOrderColNm } from "constants/jobOrderConstant"
import PopoverDefault from "components/PopoverDefault"
import PopoverSearchJobOrder from "components/PopoverSerachJobOrder/PopoverSearchJobOrder"
import FileDropCell from "components/FileUplaod/FileDropCell"
import { useCallback, useContext, useEffect, useState } from "react"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import { getDataAndPrintWht } from "utils/getDataAndPrintWht"
import { invoiceColNm } from "constants/invoiceConstant"
import { renderEditCellAutocomplete } from "components/DataGridCellExpand/renderEditCellAutocomplete"
import { UserContext } from "contexts/UserContext"

const renderUploadCell = ({ uploadApiNm, formDataKey, handleDeleteFile, onFileUploadSuccess }) => (params) => {

  return params.id === 0 ? null : (
    <BoxFR>
      {
        params.value && params.value.length > 0 ?
          <PopoverDefault icon={<ImageRounded color="primary" />} >
            <Paper sx={{ p: 1 }}>
              <BoxFC sx={{ gap: 1 }}>
                {params.value.map((file, index) => {
                  const isImage = file.Url && /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(file.Url);

                  return (
                    <BoxFR key={index} sx={{ justifyContent: 'center', position: 'relative' }}>
                      {isImage ? (
                        <img
                          src={file.Url}
                          alt={`Preview ${index + 1}`}
                          style={{
                            maxWidth: '150px',
                            maxHeight: '100px',
                            objectFit: 'contain',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'transform 0.2s ease-in-out',
                          }}
                          onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                          onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                          onClick={() => window.open(file.Url, "_blank")}
                        />
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{
                            width: '100%',
                            p: 1,
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            backgroundColor: '#f5f5f5',
                            '&:hover': {
                              backgroundColor: '#e0e0e0',
                            },
                            maxWidth: '200px',
                            wordBreak: 'break-word',
                          }}
                          onClick={() => window.open(file.Url, "_blank")}
                        >
                          📄 {file.FileName || file.Name || `File ${index + 1}`}
                        </Typography>
                      )}

                      {/* Delete button */}
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: -8,
                          right: -8,
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 1)',
                          },
                          minWidth: '20px',
                          width: '20px',
                          height: '20px',
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteFile(file);
                        }}
                      >
                        <CloseRounded />
                      </IconButton>
                    </BoxFR>
                  );
                })}
              </BoxFC>
            </Paper>
          </PopoverDefault>
          // <IconButton sx={{ p: 0 }} onClick={()=>window.open(params.value[0].Url, "_blank")}>
          //   <ArticleRounded color="primary" />
          // </IconButton> 
          : null
      }
      <FileDropCell
        formDataObj={{ [formDataKey]: params.id }}
        uploadApiNm={uploadApiNm}
        onUploadSuccess={onFileUploadSuccess}
        colNm={params.colDef.field}
        hasValue={params.value?.length > 0}
      />
    </BoxFR>
  );
};

export const pettyCashColumns = ({ handleDeleteFile, onFileUploadSuccess }) => [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id }) => {
      return id === 0 ? null : (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },

  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: "center"
  },
  {
    field: "Files",
    headerName: "ไฟล์",
    width: 100,
    align: "center",
    renderCell: renderUploadCell({
      uploadApiNm: pettyCashApiNm.uploadFilePCTransaction,
      formDataKey: "PCTrnsId",
      handleDeleteFile,
      onFileUploadSuccess
    }),
  },
  {
    field: "UsrNNm",
    headerName: pettyCashColNm.UsrNNm,
    width: 100,
  },
  {
    field: "PayTm",
    headerName: pettyCashColNm.PayTm,
    width: 120,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm:ss") : "-";
    },
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    width: 180,
    valueGetter: ({ row, value }) => !value ? "-" : `${row.PrPCTrnsId ? row.InOutTyp === "I" ? "(เงินทอน)" : "(เงินเพิ่ม)" : ""}${row.ExpNm}`
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    width: 120,
    editable: true,
  },
  {
    field: "JobOrdId",
    headerName: pettyCashColNm.JobOrdId,
    width: 100,
  },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    width: 100,
  },
  {
    field: "Bkg",
    headerName: jobOrderColNm.Bkg,
    width: 100,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "Loc",
    headerName: "สถานที่",
    valueGetter: ({ row }) => row.TakePlc || row.Loc || row.RtnPlc ? `${row.TakePlc}-${row.Loc}-${row.RtnPlc}` : "",
    width: 200,
  },
  {
    field: "PCJnlNm",
    headerName: pettyCashColNm.PCJnlNm,
    width: 100,
  },
  // {
  //   field: "Amnt",
  //   headerName: pettyCashColNm.Amnt,
  //   width: 90,
  //   align: "right",
  // },
  {
    field: "WhtPrct",
    headerName: pettyCashColNm.WhtPrct,
    width: 50,
    valueGetter: ({ id, value }) => id === 0 ? "" : `${value || 0}%`,
    align: "right",
  },
  {
    field: "AmntOut",
    headerName: "เงินจ่าย",
    width: 100,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value && +params.value > 0 ? numberFormat(params.value) : "",
  },
  {
    field: "AmntIn",
    headerName: "เงินรับ",
    width: 100,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value && +params.value > 0 ? numberFormat(params.value) : "",
  },
  {
    field: "AdmNNm",
    headerName: pettyCashColNm.AdmNNm,
    width: 100,
  },
  {
    field: "PrIsCmpt",
    headerName: pettyCashColNm.IsCmpt,
    width: 50,
    align: "center",
    valueFormatter: (params) => params.value ? <Typography color="success">✔</Typography> : "",
    cellClassName: ({ value }) => value ? "complete" : "",
    // renderCell: ({value})=> value===1? <CheckCircleRounded color="success"/>: ""
  },
  {
    field: "PCPrdId",
    headerName: "ยืนยันยอดแล้ว",
    width: 50,
    align: "center",
    valueFormatter: (params) => params.value ? <Typography color="success">✔</Typography> : "",
    // renderCell: ({value})=> value===1? <CheckCircleRounded color="success"/>: ""
  },
  {
    field: "PrIsRdyXpss",
    headerName: pettyCashColNm.IsRdyXpss,
    width: 50,
    align: "center",
    valueFormatter: (params) => params.value ? <Typography color="success">✔</Typography> : "",
    cellClassName: ({ value }) => value ? "ready-express" : "",
    // renderCell: ({value})=> value===1? <CheckCircleRounded color="success"/>: ""
  },
  {
    field: "CtrlCd",
    headerName: pettyCashColNm.CtrlCd,
    width: 100,
    editable: true,
  },
  {
    field: "PCTrnsId",
    headerName: pettyCashColNm.PCTrnsId,
    width: 80,
    editable: false,
  },
  {
    field: "MvPCTrnsId",
    headerName: "ย้าย transaction",
    width: 40,
    renderCell: () => (
      <IconButton>
        <SwapHorizRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุ",
    flex: 1,
    editable: true,
    minWidth: 120,
  },
]

export const pcTransColumns = ({ handleDeleteFile, onFileUploadSuccess }) => [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <EditRounded color={params.row.PrIsCmpt ? "disabled" : "primary"} />
        </IconButton>
      )
    }
  },
  ...pettyCashColumns({ handleDeleteFile, onFileUploadSuccess }).filter(col => col.field !== "ShowDetail")
]

const WHTPaper = ({ row }) => {
  const { ax, msData } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)
  const [whtPrintData, setWhtPrintData] = useState({
    WhtPayrTyp: "A",
    WhtTypId: 5,
    WhtTypOthTxt: "",
  })

  const whtPrintTextFieldProps = useCallback((name) => ({
    size: "small",
    value: whtPrintData[name],
    onChange: (e) => { setWhtPrintData(o => ({ ...o, [name]: e.target.value })) }
  }), [whtPrintData])


  const handlePrintWht = useCallback(() => {
    const postData = {
      ColValues: {
        IsShowPrintWht: true,
        WhtTypId: whtPrintData.WhtTypId,
        WhtPayrTyp: whtPrintData.WhtPayrTyp,
      },
      PCItmId: row.PCItmId,
    }
    ax.post(pettyCashApiNm.updatePCItemCols, postData, false)
    getDataAndPrintWht({
      ax, user,
      dialogData: { ...row, ...whtPrintData },
      companyData: msData.serverData.CompanyData,
    })
  }, [ax, row, whtPrintData, msData.serverData.CompanyData, user])

  useEffect(() => {
    setWhtPrintData({ ...row })
  }, [row])
  return (
    <Paper sx={{ p: 1 }}>
      <BoxFR>
        <TextField {...whtPrintTextFieldProps("WhtPayrTyp")} label="ผู้หัก ณ ที่จ่าย" select >
          <MenuItem value={"A"}>กระทำการแทน</MenuItem>
          <MenuItem value={"O"}>บริษัททำการหัก</MenuItem>
          <MenuItem value={"C"}>ลูกค้าทำการหัก</MenuItem>
        </TextField>
        <TextField {...whtPrintTextFieldProps("WhtTypId")} label="ประเภทหัก" select >
          <MenuItem value={1}>ค่าขนส่ง</MenuItem>
          <MenuItem value={2}>ค่าจ้างทำของ</MenuItem>
          <MenuItem value={3}>ค่าโฆษณา</MenuItem>
          <MenuItem value={4}>ค่าเช่า</MenuItem>
          <MenuItem value={5}>ค่าบริการ</MenuItem>
          <MenuItem value={6}>อื่นๆ</MenuItem>
          {/* <MenuItem value={0}>อื่นๆ</MenuItem> */}
        </TextField>
        {whtPrintData.WhtTypId === 6 ?
          <TextField {...whtPrintTextFieldProps("WhtTypOthTxt")} label="รายละเอียดอื่นๆ" sx={{ width: 100 }} />
          : null
        }
        {/* <TextField {...whtPrintTextFieldProps("WhtTypOthTxt")} label="รายละเอียดอื่นๆ" 
            disabled={whtPrintData.WhtTyp === 5? true:false}/> */}
        <Button variant="contained" onClick={handlePrintWht}><PrintRounded sx={{ mr: 1 }} />พิมพ์</Button>
      </BoxFR>
    </Paper>
  )
}

export const pcItemColumns = ({ handleChangeIsCost, handleChangeIsOwnRcpt, handlePopoverSearchOpen, handleSelectJobOrder
  , handleDeleteFile, onFileUploadSuccess, suggestDrvId, suggestPOIIds }) => [
    {
      field: 'ShowDetail',
      headerName: '',
      width: 40,
      align: 'center',
      renderCell: (params) => {
        return (
          <IconButton size="small" >
            <EditRounded color={params.row.PrIsCmpt ? "disabled" : "primary"} />
          </IconButton>
        )
      }
    },
    {
      field: "No",
      headerName: "No.",
      width: 50,
      align: "center"
    },
    {
      field: "Files",
      headerName: "ไฟล์",
      width: 100,
      align: "center",
      renderCell: renderUploadCell({
        uploadApiNm: pettyCashApiNm.uploadFilePCItem,
        formDataKey: "PCItmId",
        handleDeleteFile,
        onFileUploadSuccess
      }),
    },
    {
      field: "PCItmTm",
      headerName: pettyCashColNm.ItmDte,
      width: 110,
      type: "dateTime",
      valueFormatter: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
      },
    },
    {
      field: "IsCost",
      headerName: "รายได้/ต้นทุน",
      width: 80,
      valueFormatter: ({ value }) => value === 1 ? "ต้นทุน" : value === 0 ? "รายได้" : "-",
      cellClassName: ({ value }) => value === 1 ? "cost" : value === 0 ? "income" : "xxx",
      renderCell: ({ id, value }) => id === 0 ? null : (
        <BoxFR sx={{gap: 0}}>
          <Typography variant="body2">{value === 1 ? "ต้นทุน" : value === 0 ? "รายได้" : "-"}</Typography>
          <IconButton color="primary" onClick={() => handleChangeIsCost(id, value === 1 ? 0 : 1)}>
            <SwapHorizRounded />
          </IconButton>
        </BoxFR>
      )
    },
    {
      field: "IsOwnRcpt",
      headerName: "ใบเสร็จ บริษัท/ลูกค้า",
      width: 80,
      valueFormatter: ({ value }) => value === 1 ? "บริษัท" : value === 0 ? "ลูกค้า" : "-",
      cellClassName: ({ value, row }) => row.IsCost === 1 ? "" : value === 1 ? "own-rcpt" : value === 0 ? "cus-rcpt" : "xxx",
      renderCell: ({ id, value, row }) => id === 0 ? null : (
        <BoxFR sx={{gap: 0}}>
          <Typography variant="body2">{row.IsCost === 1 ? "-" :  value === 1 ? "บริษัท" : value === 0 ? "ลูกค้า" : "-"}</Typography>
          <IconButton color="primary" onClick={() => handleChangeIsOwnRcpt(id, value === 1 ? 0 : 1)}>
            <SwapHorizRounded />
          </IconButton>
        </BoxFR>
      )
    },
    {
      field: "ExpNm",
      headerName: pettyCashColNm.ExpNm,
      width: 150,
      valueGetter: (params) => params.value || "-"
    },
    {
      field: "Dscp",
      headerName: pettyCashColNm.Dscp,
      width: 100,
      editable: true,
    },
    {
      field: "DocNo",
      headerName: pettyCashColNm.DocNo,
      width: 100,
      editable: true,
    },
    {
      field: "DocDte",
      headerName: pettyCashColNm.DocDte,
      width: 110,
      type: "date",
      valueFormatter: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
      },
      editable: true,
    },
    {
      field: "JobOrdId",
      headerName: pettyCashColNm.JobOrdId,
      width: 100,
      renderCell: ({ id, value }) => id === 0 ? null : (
        <BoxFR>
          <PopoverSearchJobOrder onOpen={handlePopoverSearchOpen(id)}
            handleSelectJobOrder={handleSelectJobOrder}
            suggestDrvId={suggestDrvId}
            suggestPOIIds={suggestPOIIds} />
          {value || ""}
        </BoxFR>
      ),
      editable: true,
    },
    {
      field: "Loc",
      headerName: pettyCashColNm.Loc,
      width: 150,
    },
    {
      field: "AdmNNm",
      headerName: pettyCashColNm.AdmNNm,
      width: 80,
    },
    {
      field: "Amnt",
      headerName: pettyCashColNm.Amnt,
      width: 90,
      align: "right",
    },
    {
      field: "WhtPrct",
      headerName: pettyCashColNm.WhtPrct,
      width: 50,
      valueGetter: ({ value }) => `${value || 0}%`,
      align: "right",
    },
    {
      field: "PayAmnt",
      headerName: pettyCashColNm.PayAmnt,
      width: 90,
      align: "right",
    },
    {
      field: "CtrlCd",
      headerName: pettyCashColNm.CtrlCd,
      width: 100,
      editable: true,
    },
    {
      field: "Rcpt",
      headerName: "ชื่อ-ที่อยู่ ใบเสร็จ",
      width: 50,
      align: "center",
      renderCell: ({ row: { RcptNm, RcptAddr, RcptTaxId, RcptBrchNo, RcptPortCd } }) => RcptNm ?
        <PopoverDefault icon={<ReceiptRounded color="primary" />}>
          <Paper sx={{ p: 2, width: 300 }}>
            <Typography ><strong>ชื่อ: </strong> {RcptNm}</Typography>
            <Typography ><strong>ที่อยู่: </strong> {RcptAddr}</Typography>
            <Typography ><strong>TAX ID: </strong>{RcptTaxId}</Typography>
            <Typography >{RcptBrchNo === 0 ? "สำนักงานใหญ่" : `สาขา: ${RcptBrchNo?.toString().padStart(5, "0")}`}</Typography>
            <Typography ><strong>รหัสแลกผ่านท่า: </strong>{RcptPortCd}</Typography>
          </Paper>
        </PopoverDefault> : "",
    },
    {
      field: "SupSNm",
      headerName: pettyCashColNm.SupSNm,
      width: 100,
    },
    {
      field: "PrintWht",
      headerName: "พิมพ์หัก ณ ที่จ่าย",
      width: 60,
      align: "center",
      renderCell: ({ row }) => (
        <PopoverDefault icon={<PrintRounded color="primary" />}>
          <WHTPaper row={row} />
        </PopoverDefault>
      )
    },

    {
      field: "PCItmId",
      headerName: pettyCashColNm.PCItmId,
      width: 80,
      editable: false,
    },
    {
      field: "MvPCTrnsId",
      headerName: "ย้าย transaction",
      width: 40,
      renderCell: () => (
        <IconButton>
          <SwapHorizRounded color="primary" />
        </IconButton>
      )
    },
    {
      field: "Rmk",
      headerName: "หมายเหตุ",
      flex: 1,
      minWidth: 100,
      editable: true,
    },
  ]

const whatPayrTypOptions = [
  { value: null, label: "-" },
  { value: "A", label: "กระทำการแทน" },
  { value: "O", label: "บริษัททำการหัก" },
  { value: "C", label: "ลูกค้าทำการหัก" }
]

export const pcItemAddTableColumns = ({ handleChangeIsCost, handleRemoveRow, handlePopoverSearchOpen
  , handleSelectJobOrder, suggestDrvId, whtTypeCombo, supplierCombo = [] }) => [
    {
      field: "No",
      headerName: "No.",
      width: 30,
      minWidth: 30,
      align: "center"
    },
    {
      field: "IsCost",
      headerName: expenseColNm.IsCost,
      width: 80,
      cellClassName: ({ value }) => value === 1 ? "cost" : value === 0 ? "income" : "",
      renderCell: ({ id, value }) => id === 0 ? null : (
        <BoxFR sx={{ gap: 0 }}>
          <Typography variant="body2">{value === 1 ? "ต้นทุน" : value === 0 ? "รายได้" : "-"}</Typography>
          <IconButton color="primary" onClick={() => handleChangeIsCost(id, "IsCost")}>
            <SwapHorizRounded />
          </IconButton>
        </BoxFR>
      )
    },
    {
      field: "IsOwnRcpt",
      headerName: expenseColNm.IsOwnRcpt,
      width: 80,
      renderCell: ({ id, value, row }) => id === 0 ? null : (
        <BoxFR sx={{ gap: 0 }}>
          <Typography variant="body2">{row.IsCost === 1 ? "-"
            : value === 1 ? "บริษัท" : value === 0 ? "ลูกค้า" : "-"}</Typography>
          {
            row.IsCost === 1 ? null :
              <IconButton color="primary" onClick={() => handleChangeIsCost(id, "IsOwnRcpt")}>
                <SwapHorizRounded />
              </IconButton>
          }
        </BoxFR>
      )
    },
    {
      field: "ExpNm",
      headerName: pettyCashColNm.ExpNm,
      width: 130,
      valueGetter: (params) => params.value || "-"
    },
    {
      field: "JobOrdId",
      headerName: pettyCashColNm.JobOrdId,
      width: 100,
      valueGetter: (params) => params.value || "-",
      editable: true,
      renderCell: ({ id, value, row }) => id === 0 ? null : (
        <BoxFR sx={{ gap: 0 }}>
          <PopoverSearchJobOrder onOpen={handlePopoverSearchOpen(id)}
            handleSelectJobOrder={handleSelectJobOrder}
            suggestDrvId={suggestDrvId}
            suggestPOIIds={[row.TakePOIId, row.RtnPOIId]} />
          {value || ""}
        </BoxFR>
      )
    },
    {
      field: "Loc",
      headerName: pettyCashColNm.LocText,
      width: 150,
      valueGetter: (params) => params.value || "-",
      renderCell: ({ row, value }) => row.IsLoading ? <CircularProgress size={20} /> : value || "-"
    },
    {
      field: "Dscp",
      headerName: pettyCashColNm.Dscp,
      flex: 1,
      minWidth: 100,
      editable: true,
    },
    {
      field: "DocNo",
      headerName: pettyCashColNm.DocNo,
      width: 100,
      editable: true,
    },
    {
      field: "DocDte",
      headerName: pettyCashColNm.DocDte,
      width: 110,
      type: "date",
      valueFormatter: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
      },
      editable: true,
    },
    {
      field: "VatPrct",
      type: "number",
      headerName: pettyCashColNm.VatPrct,
      width: 50,
      valueGetter: ({ value, id }) => id === 0 ? "" : `${value || 0}%`,
      align: "right",
      editable: true,
    },
    {
      field: "AmntB4Vat",
      type: "number",
      headerName: pettyCashColNm.AmntB4Vat,
      Amnt: "จำนวนเงิน",
      width: 90,
      align: "right",
      editable: true,
      valueFormatter: ({ value }) => value ? numberFormat(value) : "0.00"
    },
    {
      field: "Amnt",
      type: "number",
      headerName: pettyCashColNm.Amnt,
      width: 90,
      align: "right",
      editable: true,
      valueFormatter: ({ value }) => value ? numberFormat(value) : "0.00"
    },
    {
      field: "WhtPrct",
      type: "number",
      headerName: pettyCashColNm.WhtPrct,
      width: 50,
      valueGetter: ({ value, id }) => id === 0 ? "" : `${value || 0}%`,
      align: "right",
      editable: true,
    },
    {
      field: "WhtPayrTyp",
      headerName: pettyCashColNm.WhtPayrTyp,
      width: 80,
      type: "singleSelect",
      valueOptions: whatPayrTypOptions,
      valueGetter: ({ value, id }) => whatPayrTypOptions.find(v => v.value === value)?.label || "",
      editable: true,
    },
    {
      field: "SupId",
      headerName: pettyCashColNm.SupId,
      width: 150,
      valueFormatter: ({ value }) => supplierCombo.find(v => v.id === value)?.label || "",
      renderEditCell: renderEditCellAutocomplete(supplierCombo),
      editable: true,
    },
    {
      field: "PayAmnt",
      headerName: pettyCashColNm.PayAmnt,
      width: 90,
      align: "right",
      valueFormatter: ({ value }) => value ? numberFormat(value) : "0.00"
    },
    {
      field: "WhtTypId",
      headerName: pettyCashColNm.WhtTypId,
      width: 80,
      type: "singleSelect",
      valueOptions: whtTypeCombo.map(v => ({ value: v.id, label: v.label })),
      valueGetter: ({ value, id }) => whtTypeCombo.find(v => v.id === value)?.label || "",
      editable: true,
    },
    // {
    //   field: "PCJnlId",
    //   headerName: pettyCashColNm.PCJnlId,
    //   width: 100,
    //   renderCell: ({ id, value }) => id === 0 ? null : (
    //     <TextField value={value} sx={{ width: 190, p: 0 }} select size="small" error={value ? false : true}
    //       onChange={e => handlePCJnlIdChange(id, e.target.value)} >
    //       {pcJournalCombo.map((item) => (
    //         <MenuItem key={item.id} value={item.id}>
    //           {item.label}
    //         </MenuItem>
    //       ))}
    //     </TextField>
    //   ),
    //   cellClassName: "select",
    // },
    {
      field: "actions",
      type: "actions",
      width: 25,
      minWidth: 0,
      getActions: (params) => params.id === 0 ? [] : [
        <GridActionsCellItem
          icon={<RemoveCircleRounded />}
          label="Remove"
          onClick={() => handleRemoveRow(params.row)}
        />
      ]
    },
  ]

export const pettyCashForBalSelectColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return params.id === 0 ? null : (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: "center"
  },
  {
    field: "UsrNNm",
    headerName: pettyCashColNm.UsrNNm,
    width: 100,
  },
  {
    field: "PayTm",
    headerName: pettyCashColNm.PayTm,
    width: 120,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm:ss") : "-";
    },
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    width: 180,
    valueGetter: ({ row, value }) => !value ? "-" : `${row.PrPCTrnsId ? row.InOutTyp === "I" ? "(รับเงิน)" : "(เงินเพิ่ม)" : ""}${row.ExpNm}`
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    width: 120,
  },
  {
    field: "Loc",
    headerName: "สถานที่",
    valueGetter: ({ row }) => row.TakePlc || row.Loc || row.RtnPlc ? `${row.TakePlc}-${row.Loc}-${row.RtnPlc}` : "",
    width: 200,
  },
  {
    field: "AmntOut",
    headerName: "เงินจ่าย",
    width: 100,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value ? numberFormat(params.value) : "",
  },
  {
    field: "AmntIn",
    headerName: "เงินรับ",
    width: 100,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value ? numberFormat(params.value) : "",
  },
  {
    field: "AdmNNm",
    headerName: pettyCashColNm.AdmNNm,
    width: 100,
  },
]

export const pcPeriodColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "PCJnlNm",
    headerName: "บัญชี",
    width: 80,
  },
  {
    field: "AdmNNm",
    headerName: "ผู้ทำรายการ",
    width: 100,
  },
  {
    field: "PCPrdTm",
    headerName: "เวลายืนยันยอด",
    width: 140,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
  {
    field: "NumAll",
    headerName: "จำนวนรายการ",
    width: 90,
    align: 'center',
  },
  {
    field: "SumOut",
    headerName: "รวมยอดเงิน จ่าย",
    width: 110,
    valueFormatter: ({ value }) => value ? numberFormat(+value) : "0",
    align: 'right',
  },
  {
    field: "SumIn",
    headerName: "รวมยอดเงิน รับ",
    width: 110,
    valueFormatter: ({ value }) => value ? numberFormat(+value) : "0",
    align: 'right',
  },
  {
    field: "Bal",
    headerName: "ยอดคงเหลือ",
    width: 110,
    valueFormatter: ({ value }) => value ? numberFormat(+value) : "0",
    align: 'right',
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุ",
    flex: 1,
    minWidth: 120,
  },
]

export const shorePeriodColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return params.id === 0 ? null : (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: "center"
  },
  {
    field: "PayTm",
    headerName: pettyCashColNm.PayTm,
    width: 120,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm:ss") : "-";
    },
  },
  {
    field: "UsrNNm",
    headerName: pettyCashColNm.UsrNNm,
    width: 90,
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    flex: 1,
    minWidth: 120,
    valueGetter: ({ row, value }) => !value ? "-" : `${row.PrPCTrnsId ? row.InOutTyp === "I" ? "(รับเงิน)" : "(เงินเพิ่ม)" : ""}${row.ExpNm}`
  },
  {
    field: "JobOrdId",
    headerName: pettyCashColNm.JobOrdId,
    width: 70,
  },
  {
    field: "Loc",
    headerName: "สถานที่",
    valueGetter: ({ row }) => `${row.TakePlc || ""}-${row.Loc || ""}-${row.RtnPlc || ""}`,
    width: 150,
  },
  {
    field: "ContNo",
    headerName: "หมายเลขตู้",
    width: 120,
  },
  {
    field: "ContSizeFull",
    headerName: "ขนาดตู้",
    width: 60,
  },
  {
    field: "Amnt",
    headerName: pettyCashColNm.Amnt,
    width: 90,
    align: "right",
  },
  {
    field: "WhtPrct",
    headerName: pettyCashColNm.WhtPrct,
    width: 60,
    valueGetter: ({ value }) => `${value || 0}%`,
    align: "right",
  },
  {
    field: "OutAmnt",
    headerName: "เงินจ่าย",
    width: 100,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value ? numberFormat(params.value) : "",
  },
  {
    field: "InAmnt",
    headerName: "เงินรับ",
    width: 100,
    align: "right",
    type: "number",
    valueFormatter: (params) => params.value ? numberFormat(params.value) : "",
  },
  {
    field: "IsCmpt",
    headerName: "สมบูรณ์",
    width: 40,
    valueFormatter: ({ value }) => value ? "✔" : "",
    align: 'right',
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    width: 120,
  },
  {
    field: "AdmNNm",
    headerName: pettyCashColNm.AdmNNm,
    width: 90,
  },
]

export const pcItemDataColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id }) => id === 0 ? null : (
      <IconButton size="small" >
        <ArticleRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "PCItmTm",
    headerName: pettyCashColNm.PCItmTm,
    width: 110,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "UsrNNm",
    headerName: pettyCashColNm.UsrNNm,
    width: 100,
  },
  {
    field: "IsCost",
    headerName: pettyCashColNm.IsCost,
    width: 80,
    cellClassName: (params) => params.value == null ? null : params.value === 1 ? "isCost" : "isExp",
    valueFormatter: (params) => params.value == null ? null : params.value === 1 ? `ต้นทุน` : `รายได้`,
  },
  {
    field: "ExpNm",
    headerName: expenseColNm.ExpNm,
    width: 160,
  },
  {
    field: "JobOrdId",
    headerName: jobOrderColNm.JobOrdId,
    width: 90,
  },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    width: 100,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSizeFull,
    width: 70,
  },
  {
    field: "Loc",
    valueGetter: ({ row }) => `${row.TakePlc || ""}-${row.Loc || ""}-${row.RtnPlc || ""}`,
    headerName: jobOrderColNm.Loc,
    width: 180,
  },
  {
    field: "Amnt",
    headerName: pettyCashColNm.Amnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "WhtPrct",
    headerName: pettyCashColNm.WhtPrct,
    width: 70,
    type: "number",
    align: "right",
    valueFormatter: ({ id, value }) => id === 0 ? null : value ? `${numberFormat(value)}%` : "0%",
  },
  {
    field: "PayAmnt",
    headerName: pettyCashColNm.PayAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "DocNo",
    headerName: pettyCashColNm.DocNo,
    width: 120,
    editable: true,
  },
  {
    field: "DocDte",
    headerName: pettyCashColNm.DocDte,
    width: 110,
    type: "date",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    flex: 1,
    minWidth: 120,
    editable: true,
  },
  {
    field: "CtrlCd",
    headerName: pettyCashColNm.CtrlCd,
    width: 120,
    editable: true,

  },
  {
    field: "Rmk",
    headerName: pettyCashColNm.Rmk,
    flex: 1,
    minWidth: 200,
    editable: true,
  },
]

export const notIsCmptColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({ id }) => id === 0 ? null : (
      <IconButton size="small" >
        <ArticleRounded color="primary" />
      </IconButton>
    )

  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "PayTm",
    headerName: pettyCashColNm.PayTm,
    width: 120,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm:ss") : "-";
    },
  },
  {
    field: "UsrNNm",
    headerName: pettyCashColNm.UsrNNm,
    width: 100,
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    width: 150,
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    width: 110,
  },
  {
    field: "JobSNm",
    headerName: jobOrderColNm.JobSNm,
    width: 120,
  },
  {
    field: "JobNo",
    headerName: pettyCashColNm.JobNo,
    width: 120,
  },
  {
    field: "ContNo",
    headerName: pettyCashColNm.ContNo,
    width: 120,
  },
  {
    field: "JobOrdId",
    headerName: pettyCashColNm.JobOrdId,
    width: 90,
  },
  {
    field: "PCJnlNm",
    headerName: pettyCashColNm.PCJnlNm,
    width: 80,
  },
  {
    field: "InOutAmnt",
    headerName: pettyCashColNm.InOutAmnt,
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "ChdAmnt",
    headerName: "เงินทอน/เพิ่ม",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "PIAmnt",
    headerName: "ใช้เงิน",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "LeftAmnt",
    headerName: "เงินค้าง",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุ",
    flex: 1,
    minWidth: 120,
  },
]


export const driverStatementColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return params.id === 0 ? null : (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "PCJnlNm",
    headerName: pettyCashColNm.PCJnlNm,
    width: 100,
  },
  {
    field: "PayTm",
    headerName: "เวลาทำรายการ",
    width: 120,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    minWidth: 130,
    flex: 1,
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    minWidth: 130,
    flex: 1,
  },
  {
    field: "JobOrdId",
    headerName: pettyCashColNm.JobOrdId,
    width: 100,
  },
  {
    field: "ContNo",
    headerName: pettyCashColNm.ContNo,
    width: 120,
  },
  {
    field: "JobNo",
    headerName: pettyCashColNm.JobNo,
    width: 130,
  },
  {
    field: "OutAmnt",
    headerName: "เงินจ่าย",
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "",
  },
  {
    field: "InAmnt",
    headerName: "เงินทอน/ใช้",
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "",
  },
  {
    field: "Bal",
    headerName: "เงินคงเหลือ",
    width: 100,
    align: "right",
    valueFormatter: ({ value, id }) => id === 0 ? "" : value ? numberFormat(value) : "0.00",
  },
  {
    field: "CtrlCd",
    headerName: pettyCashColNm.CtrlCd,
    width: 150,
  },
]


const whtPayrTypOptions = [
  { value: "A", label: "กระทำการแทน" },
  { value: "O", label: "บริษัททำการหัก" },
  { value: "C", label: "ลูกค้าทำการหัก" },
]

export const whtReportColumn = ({ supplierCombo = [], whtTypeCombo = [] } = {}) => [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return params.id === 0 ? null : (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: "center"
  },
  {
    field: "PCItmTm",
    headerName: pettyCashColNm.PCItmTm,
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  },
  // {
  //   field: "AptTm",
  //   headerName: jobOrderColNm.AptTm,
  //   width: 100,
  //   type: "dateTime",
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  // },
  {
    field: "DocDte",
    headerName: pettyCashColNm.DocDte,
    width: 100,
    type: "date",
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-",
  },
  {
    field: "DocNo",
    headerName: pettyCashColNm.DocNo,
    width: 100,
  },
  {
    field: "JobOrdId",
    headerName: jobOrderColNm.JobOrdId,
    width: 90,
  },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    width: 120,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "JobSNm",
    headerName: "งาน",
    width: 120,
  },
  {
    field: "TakePlc",
    headerName: jobOrderColNm.TakePlc,
    width: 80,
  },
  {
    field: "RtnPlc",
    headerName: jobOrderColNm.RtnPlc,
    width: 80,
  },
  {
    field: "CusSNm",
    headerName: "ลูกค้า",
    width: 120,
  },
  {
    field: "Amnt",
    headerName: pettyCashColNm.Amnt,
    width: 100,
    align: "right",
    type: "number",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  // {
  //   field: "VatPrct",
  //   headerName: pettyCashColNm.VatPrct,
  //   width: 70,
  //   align: "right",
  //   valueFormatter: ({ value, id }) => id === 0 ? "" : `${value || 0}%`,
  // },
  {
    field: "VatPr",
    headerName: "VAT",
    width: 70,
    align: "right",
    type: "number",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "B4Vat",
    headerName: "ก่อน VAT",
    width: 100,
    align: "right",
    type: "number",
    valueGetter: ({ row }) => row.Amnt - row.VatPr,
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  // {
  //   field: "WhtPrct",
  //   headerName: pettyCashColNm.WhtPrct,
  //   width: 70,
  //   align: "right",
  //   valueFormatter: ({ value, id }) => id === 0 ? "" : `${value || 0}%`,
  // },
  {
    field: "WhtPr",
    headerName: "WHT",
    width: 70,
    align: "right",
    type: "number",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "WhtTypId",
    headerName: pettyCashColNm.WhtTypId,
    width: 110,
    type: "singleSelect",
    valueOptions: whtTypeCombo.map(v => ({ value: v.id, label: v.label })),
    valueFormatter: ({ value }) => whtTypeCombo.find(v => v.id === value)?.label || "",
    editable: true,
  },
  {
    field: "WhtPayrTyp",
    headerName: pettyCashColNm.WhtPayrTyp,
    width: 130,
    type: "singleSelect",
    valueOptions: whtPayrTypOptions,
    valueFormatter: ({ value }) => whtPayrTypOptions.find(v => v.value === value)?.label || "",
    editable: true,
  },
  {
    field: "Rcpt",
    headerName: "ใบเสร็จ",
    width: 40,
    renderCell: ({ id, row }) => id === 0 ? null : <IconButton> <ReceiptRounded color="primary" /></IconButton>
  },
  {
    field: "PrintWht",
    headerName: "พิมพ์ WHT",
    width: 70,
    align: "center",
    renderCell: ({ id, row }) => id === 0 ? null : (
      row.WhtPrct > 0 && (
        <IconButton size="small">
          <PrintRounded color="primary" />
        </IconButton>
      )
    ),
  },
  {
    field: "SupId",
    headerName: pettyCashColNm.SupId,
    width: 150,
    valueFormatter: ({ value }) => supplierCombo.find(v => v.id === value)?.label || "",
    renderEditCell: renderEditCellAutocomplete(supplierCombo),
    editable: true,
  },
  {
    field: "RcptNm",
    headerName: "ชื่อใบเสร็จ",
    width: 120,
  },
  {
    field: "InvNo",
    headerName: invoiceColNm.InvNo,
    width: 120,
  },
  {
    field: "InvDte",
    headerName: invoiceColNm.InvDte,
    width: 110,
    type: "date",
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-",
  },
]